import React from 'react'
import { currencySymbol } from '../utils/currency';

class MachinePromoterFeesTable extends React.Component {
  render() {
    const { machine } = this.props

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Locker Basic</th>
              <th scope="col">Locker Basic XL</th>
              <th scope="col">Locker Charger</th>
              <th scope="col">Locker Charger XL</th>
              <th scope="col">Tumbonas</th>
              <th scope="col">Flotadores día</th>
              <th scope="col">Flotadores medio día</th>
              <th scope="col">Fastpass</th>
            </tr>
          </thead>
          <tbody>
            <tr key={machine.Serial}>
              <td>{machine.Promoter_fees['LOCKERBASIC']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['LOCKERBASICXL']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['LOCKERCHARGER']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['LOCKERCHARGERXL']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['TUMBONAS']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['FLOTADORES']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['FLOTADORESHALFDAY']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['FASTPASS']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['VWPACK']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['VWLAY']} {currencySymbol()}</td>
              <td>{machine.Promoter_fees['VWGO']} {currencySymbol()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default MachinePromoterFeesTable


